module.exports = __webpack_public_path__ + "a4f6b39fd67fc74ce21631dd85d9cbc1.svg";